export default __webpack_public_path__ + "static/media/music-developer-designer.3c4ec953.svg";